import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=740d7819&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"
import style0 from "./Dev.vue?vue&type=style&index=0&id=740d7819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d7819",
  null
  
)

export default component.exports